import { GalleryData } from "./GalleryData";
import { useEffect, useState } from "react";
function App() {
  const [data, setData] = useState([]);
  const [collection, setCollection] = useState([]);

  useEffect(() => {
    setData(GalleryData);
    setCollection([...new Set(GalleryData.map((item) => item.titile))]);
  }, []);

  const gallery_filter = (itemData) => {
    const filterData = GalleryData.filter((item) => item.titile === itemData);
    setData(filterData);
  };

  return (
    <div className="App">
      <div className="galleryWrapper">
        <div className="filterItem">
          <ul>
            <li>
              <button onClick={() => setData(GalleryData)}>All</button>
            </li>
            {collection.map((item) => (
              <li>
                <button
                  onClick={() => {
                    gallery_filter(item);
                  }}
                >
                  {item}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="galleryContainer">
          {data.map((item) => (
            <div
              key={item.id}
              className="galleryItem slide-fwd-center"
              id={`a${item.id}`}
            >
              <a href={item.link}>
                <img href={item.link} src={item.image} alt="pic" />
              </a>
              <div className="item-container"> {item.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
